<div class="star-container">
      <button [style.color]="color" *ngFor="let ratingId of ratingArr; index as i" 
              [id]="'star_' + i" (click)="onClick(i + 1)" 
              [matTooltip]="ratingId + 1" matTooltipPosition="above">
        <mat-icon [ngStyle]="{'color':'white'}" class="mat-icon" svgIcon="{{showIcon(i)}}">
        </mat-icon>
      </button>
</div>
    